export default defineNuxtPlugin((nuxtApp) => {
  if (nuxtApp.$config.public.appEnv !== "production") return;

  if (process.client) {
    const initGtm = async () => {
      const { createGtm } = await import("@gtm-support/vue-gtm");
      const plugin = createGtm({
        id: "GTM-KS22B5S",
        defer: true,
        loadScript: true,
        enabled: true,
        debug: false,
        vueRouter: nuxtApp.$router as any,
      });
      nuxtApp.vueApp.use(plugin);
      removeListeners();
    };

    const events = ["scroll", "click", "keydown", "pointermove", "touchstart"];
    const removeListeners = () => {
      events.forEach((event) => {
        window.removeEventListener(event, initGtm);
      });
    };

    events.forEach((event) => {
      window.addEventListener(event, initGtm, { once: true });
    });
  }
});
